import { render, staticRenderFns } from "./EstimationPreview.vue?vue&type=template&id=504f1ac3&scoped=true"
import script from "./EstimationPreview.vue?vue&type=script&lang=js"
export * from "./EstimationPreview.vue?vue&type=script&lang=js"
import style0 from "./EstimationPreview.vue?vue&type=style&index=0&id=504f1ac3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f1ac3",
  null
  
)

export default component.exports